import { tempURL, apiURL, localURL, awsUrl } from "../config";
import { setCookie } from "./session_data";
import { Auth } from "aws-amplify";
import axios from "axios";
import $ from "jquery";
import { from } from "zen-observable";
import { getUserAuthStatus, showErrAlert } from "./common";
import { awsUrl2 } from "../config";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
require("bootstrap");

export async function signIn(e) {
  e.preventDefault();
  let validForm = validateForm();
  if (validForm) {
    $("#loader").css("display", "block");
    const username = $("#userId").val();
    const password = $("#userPassword").val();
    try {
      var userTemp = await Auth.signIn(username.toLowerCase(), password);

      if (userTemp.signInUserSession !== null) {
        const userData = {
          email_id: username.toLowerCase(),
          stage: process.env.REACT_APP_MODE,
          client: "Fuba"
        }
        try {
          await axios.post(awsUrl2 + "/api/trackUserSession", userData)
          console.log("UserSessionManagement table is updated")
        } catch (error) {
          console.log("Error in updating the UserSessionManagement table")
        }
      }

      console.log("UserTemp: ", userTemp);
      if (userTemp.challengeName === "NEW_PASSWORD_REQUIRED") {
        $("#link").click();
        $("#loader").css("display", "none");
      } else {
        if (
          userTemp.signInUserSession !== null &&
          userTemp.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].includes(process.env.REACT_APP_ADMIN_GROUP)
        ) {
          console.log(
            "User Role",
            userTemp.signInUserSession.accessToken.payload["cognito:groups"]
          );
          sessionStorage.setItem("isLoggedIn", true);
          window.location.href = "./AdminDashboard";
          $("#loader").css("display", "none");
        } else if (
          userTemp.signInUserSession !== null &&
          userTemp.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].includes(process.env.REACT_APP_AGENT_GROUP)
        ) {
          console.log(
            "User Role",
            userTemp.signInUserSession.accessToken.payload["cognito:groups"]
          );
          sessionStorage.setItem("isLoggedIn", true);
          window.location.href = "./AgentDashboard";
          $("#loader").css("display", "none");
        } else if (
          userTemp.signInUserSession !== null &&
          userTemp.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].includes(process.env.REACT_APP_UW_GROUP)
        ) {
          console.log(
            "User Role",
            userTemp.signInUserSession.accessToken.payload["cognito:groups"]
          );
          sessionStorage.setItem("isLoggedIn", true);
          window.location.href = "./UWDashboard";
          $("#loader").css("display", "none");
        }
        // else if (
        //   userTemp.signInUserSession !== null &&
        //   userTemp.signInUserSession.accessToken.payload[
        //     "cognito:groups"
        //   ].includes(process.env.REACT_APP_SALES_GROUP)
        // ) {
        //   let user_email_id = userTemp.username;
        //   sessionStorage.setItem("isLoggedIn", true);
        //   sessionStorage.setItem("otpVerified", true);
        //   window.location.href = "./SalesDashboard";
        // } else if (
        //   userTemp.signInUserSession !== null &&
        //   (userTemp.signInUserSession.accessToken.payload[
        //     "cognito:groups"
        //   ].includes("Compliance") ||
        //     userTemp.signInUserSession.accessToken.payload[
        //       "cognito:groups"
        //     ].includes("ComplianceAdmin"))
        // ) {
        //   // let user_email_id = userTemp.username;
        //   sessionStorage.setItem("isLoggedIn", true);
        //   window.location.href = "./PanelCompliance";
        // } else if (
        //   userTemp.signInUserSession !== null &&
        //   userTemp.signInUserSession.accessToken.payload[
        //     "cognito:groups"
        //   ].includes(process.env.REACT_APP_PREUW_GROUP)
        // ) {
        //   sessionStorage.setItem("isLoggedIn", true);
        //   window.location.href = "./PanelUW";
        // }
        else {
          Auth.signOut()
            .then(function(res) {})
            .catch((err) => {
              console.log("error in logout: ", err);
            });
          let errMsg;
          $("#loader").css("display", "none");
          errMsg = "User does not exist!";
          $("#loginSubmit")
            .siblings(".errMsg")
            .html("<br /> " + errMsg);
        }
        console.log("In loged in page: ", userTemp);
      }
    } catch (err) {
      let errMsg;
      $("#loader").css("display", "none");
      console.log("error signing in! :", err);
      if (
        err.code === "UserNotFoundException" ||
        err.code === "NotAuthorizedException"
      ) {
        errMsg = err.message;
      } else {
        errMsg =
          "Unable to login! Please contact admin@insurecomp.com for more details!";
      }
      $("#loginSubmit")
        .siblings(".errMsg")
        .html("<br /> " + errMsg);
    }
  }
}

function validateForm() {
  var form = true;
  if (
    $("#userId").val() === "" ||
    document.getElementById("userId").style.borderColor === "red"
  ) {
    $("#userId").css("border-color", "rgb(255, 0, 0)");
    $("#userId")
      .siblings(".errMsg")
      .html("Email is required");
    $("#userId").focus();
    form = false;
  }
  if (
    $("#userPassword").val() === "" ||
    document.getElementById("userId").style.borderColor === "red"
  ) {
    $("#userPassword").css("border-color", "rgb(255, 0, 0)");
    $("#userPassword")
      .siblings(".errMsg")
      .html("Password is required");
    $("#userPassword").focus();
    form = false;
  }
  return form;
}
